// extracted by mini-css-extract-plugin
export default {"title":"M1dqIR"};